export function SortNew(jobType) {
    return {
        type: 'admin/jobSort/SORT_NEW',
        payload: jobType,
    };
}

export function SortOld(jobType) {
    return {
        type: 'admin/jobSort/SORT_OLD',
        payload: jobType,
    };
}

export function SortAtoZ(jobType) {
    return {
        type: 'admin/jobSort/SORT_AZ',
        payload: jobType,
    };
}

export function newSearch(term, jobType) {
    return {
        type: 'admin/new/SEARCH',
        term: term,
        jobType: jobType,
    };
}

export function fullSearch(term, jobType) {
    return {
        type: 'admin/full/SEARCH',
        term: term,
        jobType: jobType,
    };
}

export function completeSearch(term, jobType) {
    return {
        type: 'admin/complete/SEARCH',
        term: term,
        jobType: jobType,
    };
}
